module.exports = __webpack_public_path__ + "static/media/arrow-switch-icon.1207670d.svg";